//根级别的 mutation
import * as types from './mutation-types';
export default {}